<template>
    <div v-if="user">
        <div class="panel panel-success"  >

            <!-- Default panel contents -->
            <div class="panel-heading">
                <i class="fa fa-bars" aria-hidden="true"></i> MENU PONTOS
            </div>
            <div class="panel-body" v-if="user.level < 5" >
                <p>
                    <a :href="'#/ponto/novo'" class="btn btn-info btn-block">NOVO PONTO</a>
                </p>
            </div>

        </div>

        <div class="panel panel-danger"  v-if="ponto_id" >

            <!-- Default panel contents -->
            <div class="panel-heading">COMANDOS</div>
            <!-- List group -->
            <ul class="list-group">
                <li class="list-group-item" v-if="user.permissoes.comandos && user.level <= 5">
                    <a :href="'#/ponto/comandos/' + ponto_id" >COMANDOS</a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        ponto_id: null
    },
    data() {
        return {
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
    }
};
</script>
